var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnlockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 264 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 20837",
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 15.5C3.864 15.5.5 12.136.5 8S3.864.5 8 .5s7.5 3.364 7.5 7.5-3.364 7.5-7.5 7.5z",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 1C4.14 1 1 4.14 1 8s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7m0-1a8 8 0 1 1 0 16A8 8 0 0 1 8 0z",
    style: {
      fill: "#dfdfdf",
      stroke: "none"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20866",
    d: "M10.286 7.429H6.857V5.714a1.143 1.143 0 1 1 2.286 0h.571a1.714 1.714 0 1 0-3.429 0v1.715h-.571A.571.571 0 0 0 5.143 8v3.429a.571.571 0 0 0 .571.571h4.571a.571.571 0 0 0 .571-.571V8a.571.571 0 0 0-.57-.571z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockIcon);
export default __webpack_public_path__ + "static/media/Unlock-Icon.451f9343d5d12fb6a2dd7884f544bb70.svg";
export { ForwardRef as ReactComponent };